var _use, _use2, _use3, _use4, _use5, _use6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMys(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 2800 1400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#cc0001"
    },
    d: "M0 0h2800v1400H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "a",
    style: {
      fill: "#fff"
    },
    d: "M0 1300h2800v100H0z"
  }), _use || (_use = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -200)",
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -400)",
    xlinkHref: "#a"
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -600)",
    xlinkHref: "#a"
  })), _use4 || (_use4 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -800)",
    xlinkHref: "#a"
  })), _use5 || (_use5 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -1000)",
    xlinkHref: "#a"
  })), _use6 || (_use6 = /*#__PURE__*/React.createElement("use", {
    transform: "translate(0 -1200)",
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#010066"
    },
    d: "M0 0h1400v800H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M576 100c-166.146 0-301 134.406-301 300s134.854 300 301 300c60.027 0 115.955-17.564 162.927-47.783-27.353 9.44-56.71 14.602-87.271 14.602-147.327 0-266.897-119.172-266.897-266.01 0-146.837 119.57-266.01 266.897-266.01 32.558 0 63.746 5.815 92.602 16.468C696.217 118.91 638.305 100 576 100z",
    style: {
      fill: "#fc0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m914.286 471.429-99.538-53.25 29.43 108.982-66.575-91.165-20.77 110.96-20.428-111.024-66.857 90.96L699.314 418l-99.701 52.943 74.065-85.192-112.8 4.441 103.694-44.62-103.555-44.94L673.8 305.42 600 220l99.538 53.25-29.43-108.982 66.575 91.165 20.77-110.96 20.428 111.023 66.857-90.959L814.97 273.43l99.702-52.944-74.065 85.193 112.8-4.441-103.694 44.62 103.555 44.94-112.785-4.79z",
    transform: "matrix(1.2738 0 0 1.2423 -89.443 -29.478)",
    style: {
      fill: "#fc0"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMys);
export default __webpack_public_path__ + "static/media/mys.9e795e30573a62bda8c4d978005f1f0c.svg";
export { ForwardRef as ReactComponent };